import { z } from "zod";
import type { MembersPersonalOption } from "./api";

/**
 * The `members` search param of the Connections routes. Tolerant like the tab: a stale or
 * hand-edited address (`?members=1`) means the switch is off, not an error page.
 */
export const membersSwitchSearch = z.boolean().optional().catch(undefined);

/**
 * Whether the Connections screens read members' personal accounts too. `requested` is the
 * address's `members` switch; `canView` is the catalog's answer, undefined until it has one.
 *
 * Only an owner or admin has the switch (`available`), and only they ever send the flag: a member
 * who sends it is refused, so a stale `?members=true` in a member's address is ignored. A request
 * for the wider lists waits (`ready` false) until the catalog has said, so a reload with the switch
 * on never shows the plain list first and then grows.
 */
export function membersPersonalView({
  requested,
  canView,
}: {
  requested: boolean;
  canView: boolean | undefined;
}): {
  available: boolean;
  on: boolean;
  ready: boolean;
  options: MembersPersonalOption | undefined;
} {
  const available = canView === true;
  const on = available && requested;
  return {
    available,
    on,
    ready: !requested || canView !== undefined,
    options: on ? { membersPersonal: true } : undefined,
  };
}
